import Vue from 'vue';
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    UnassignedList: [],
    UnassignedListLoading: false,
    showBlackListAssignModal: false,
    BL_AccountSearchResults: [],
    ActivePlatforms: [],
    VendorsList: [],
    CurrentDomainInfo: ''
  }
}

const state = initialState();

const actions = {

  getUnassigned: function (context, query) {
    context.commit('updateUnassignedLoadingImg', true);
    return new Promise((resolve, reject) => {
      Vue.http.post('/platform/accountplatformdomainblacklistpaged', query).then(function(data) {
        context.commit('updateUnassignedLoadingImg', false);
        context.commit('updateUnassignedList', data.data.Data);
        resolve(data.data);
      }).catch((error) => {
        reject(error);
        context.commit('updateUnassignedLoadingImg', false);
      })
    })
  },
  setBlacklist: function (context, accountPlatformDomainBlacklistID) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/platform/setBlacklist', accountPlatformDomainBlacklistID, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (data) {
        context.commit('removeFromUnassignedList', accountPlatformDomainBlacklistID);
        resolve(data.data.Data);

      }).catch((error) => {
        reject(error);
      });
    });
  },
  addAccountPlatformDomain: function (context, domain) {

  },
  BLA_searchAccounts: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/searchdealers?accountId=' + param.accountId + '&term=' + param.searchTxt + '&internalOnly=' + param.interalOnly).then(function (data) {
        //console.log("results : ", data);
        data.data.Data.forEach(function (account) {
          account.LabelText = account.Account + " [" + account.AccountId + "]";
        });
        context.commit('updateSearchItems', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadActiveDealersForAccount: function (context, accountId) {

    return new Promise((resolve, reject) => {
      Vue.http.get('account/platforms/' + accountId).then(function (data) {
        context.commit('updatePlatforms', data.data.Data.sort(HelperFunctions.sortByProperty('Name')));
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  getAllVendorsLite: function (context, params) {

    return new Promise((resolve, reject) => {
      Vue.http.get('websitevendorslite/all').then(function (data) {
        context.commit('updateVendorList', data.data.Data.sort(HelperFunctions.sortByProperty('VendorName')));
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error);
      });
    });

  },
  addBlackListDomain: function (context, dealerInfo) {

    return new Promise((resolve, reject) => {
      Vue.http.post('vendor/addDealerToVendor', dealerInfo).then(function (data) {
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  removeDomainFromBlackList: function (context, params) {

    if (params == null)
      throw error;

    return new Promise((resolve, reject) => {
      Vue.http.delete('platform/deleteblacklistitem/' + params).then(function (data) {
        resolve(data);
      }).catch((error) => {
        reject(error)
      });
    });
  }
};

const mutations = {

  updateUnassignedList: function (state, data) {
    state.UnassignedList = data;
  },
  updateUnassignedLoadingImg: function (state, data) {
    state.UnassignedListLoading = data;
  },
  removeFromUnassignedList: function (state, accountPlatformDomainBlacklistID) {
    var index = state.UnassignedList.map(function (x) {
      return x.Id;
    }).indexOf(accountPlatformDomainBlacklistID);
    state.UnassignedList.splice(index, 1);
  },
  toggleBlackListAssignModal: function (state, data) {
    state.showBlackListAssignModal = data;
  },
  currentDomainToAdd: function (state, details) {
    state.CurrentDomainInfo = details;
  },
  updateSearchItems: function (state, data) {
    state.BL_AccountSearchResults = data;
  },
  updatePlatforms: function (state, data) {
    state.ActivePlatformsForAccountModal = data;
  },
  updateVendorList: function (state, data) {
    state.VendorsList = data;
  }

};

const getters = {
  UnassignedList: function () {
    return state.UnassignedList;
  },
  UnassignedListLoading: function () {
    return state.UnassignedListLoading;
  },
  showBlackListAssignModal: function () {
    return state.showBlackListAssignModal;
  },
  CurrentDomainInfo: function () {
    return state.CurrentDomainInfo;
  },
  BL_AccountSearchResults: function () {
    return state.BL_AccountSearchResults;
  },
  ActivePlatformsForAccount: function () {
    return state.ActivePlatformsForAccount;
  },
  VendorsList: function () {
    return state.VendorsList;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/AccountPlatformDomainBlacklist.js